import { useSelector, useDispatch } from 'react-redux'
import ErrorAlert from './../ErrorAlert'
import { t } from '../../utils/i18n'
import Popover from '../Popover'
import {
  shareSetFromEmail,
  shareSetFromName,
  shareSetToEmail,
  shareSetToName,
  shareSetMessage,
  shareSubmit
} from '../../actions'
import { bikeConfigToQuery } from '../../utils/bike-config'

const SharePopover = () => {
  const dispatch = useDispatch()
  const { bikeConfig, share } = useSelector((state) => state)
  const {
    done,
    errors,
    submitting,
    fromEmail,
    fromName,
    toEmail,
    toName,
    message
  } = share

  const query = bikeConfigToQuery(bikeConfig)

  return (
    <Popover
      minWidth={'250px'}
      width={'90%'}
      maxWidth={'500px'}
      alignTo={
        window.innerWidth > 768
          ? '.velorbis-customizer-header-share-desktop'
          : '.velorbis-customizer-header-settings'
      }
      position="below"
    >
      <div className="velorbis-customizer-popover-header">Del via e-mail</div>
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-scroll">
        {done ? (
          <div>{t('share_sent')}</div>
        ) : (
          <div className="velorbis-customizer-space-dist-v">
            <ErrorAlert errors={errors} />

            <div
              className="velorbis-customizer-responsive-columns"
              id="no-margin"
            >
              <div className="velorbis-customizer-form-control velorbis-customizer-flex-1">
                <label>{t('your_name')}</label>
                <input
                  type="text"
                  className="velorbis-customizer-input"
                  value={fromName}
                  onChange={(e) => dispatch(shareSetFromName(e.target.value))}
                />
              </div>
              <div className="velorbis-customizer-form-control velorbis-customizer-flex-1">
                <label>{t('your_email')}</label>
                <input
                  type="text"
                  className="velorbis-customizer-input"
                  value={fromEmail}
                  onChange={(e) => dispatch(shareSetFromEmail(e.target.value))}
                />
              </div>
            </div>

            <div className="velorbis-customizer-responsive-columns">
              <div className="velorbis-customizer-form-control velorbis-customizer-flex-1">
                <label>{t('recipient_name')}</label>
                <input
                  type="text"
                  className="velorbis-customizer-input"
                  value={toName}
                  onChange={(e) => dispatch(shareSetToName(e.target.value))}
                />
              </div>
              <div className="velorbis-customizer-form-control velorbis-customizer-flex-1">
                <label>{t('recipient_email')}</label>
                <input
                  type="text"
                  className="velorbis-customizer-input"
                  value={toEmail}
                  onChange={(e) => dispatch(shareSetToEmail(e.target.value))}
                />
              </div>
            </div>

            <div className="velorbis-customizer-form-control">
              <label>{t('message')}</label>
              <textarea
                className="velorbis-customizer-input"
                value={message}
                onChange={(e) => dispatch(shareSetMessage(e.target.value))}
                rows={6}
              />
            </div>

            <div className="velorbis-customizer-popover-buttons">
              <button
                className="velorbis-customizer-button"
                onClick={() => dispatch(shareSubmit())}
                disabled={submitting}
              >
                {t('send_button')}
              </button>
            </div>
          </div>
        )}
      </div>
    </Popover>
  )
}

export default SharePopover
